import React from 'react';
import CTAButton from '../HomePage/Button';
import { HighlightText } from '../HomePage/HighlightText';

const LearningGridArray = [
    {
      order: -1,
      heading: "Unleashing Potential with",
      highlightText: " Targeted Job Matches and Resources.",
      description:
        "Our partnerships with leading companies provide you with exclusive job opportunities and industry insights, ensuring a dynamic and effective career search experience.",
      BtnText: "Learn More",
      BtnLink: "/",
    },
    {
      order: 1,
      heading: "Explore IT Jobs & Internships",
      description:
        "Connect with top IT companies offering full-time jobs, remote opportunities, and paid internships to kickstart or advance your career.",
    },
    {
      order: 2,
      heading: "Mentorship Programs for Career Growth",
      description:
        "Gain industry insights and career guidance from experienced professionals through exclusive mentorship programs with leading IT firms.",
    },
    {
      order: 3,
      heading: "Build a Strong Professional Network",
      description:
        "Connect with industry experts, recruiters, and like-minded professionals to expand your career opportunities and stay updated with industry trends.",
    },
    {
      order: 4,
      heading: `Skill Enhancement & Career Development`,
      description:
        "Access expert-led training, certifications, and upskilling programs to boost your expertise and stand out in the competitive job market.",
    },
    {
      order: 5,
      heading: "Personalized Job & Internship Matches",
      description:
        "Get AI-driven job and internship recommendations tailored to your skills and aspirations, helping you find the perfect opportunity.",
    },
  ];


export const LearningGrid = () => {
  return (
        <div className='grid xls:grid-cols-4 bg-richblack-900 max-xls:gap-3 place-items-stretch justify-items-center'>
            {
                LearningGridArray.map((card , index) => {
                    return (
                        <div
                            key={index}
                            className={`
                                ${card.order < 0 && "lg:col-span-2 bg-richblack-900"}
                                
                                ${card.order % 2 == 1
                                    ? "bg-richblack-700" : "bg-richblack-800"}
                                
                                ${card.order === 3 && "xls:col-start-2"}
                                sm:w-[65%] lg:w-full hover:scale-95 transition-all duration-200 cursor-pointer`}>
                            
                            {
                                index == 0 &&   
                                <div className='lg:h-[230px] lg:w-[75%] xls:w-[90%] flex flex-col justify-between gap-4 pb-8 text-richblack-500 text-lg font-semibold'>

                                    <p className='text-4xl text-richblack-5'>
                                        {card.heading}
                                        <HighlightText text={card.highlightText} />
                                    </p>
                                
                                    <p className='mb-2'>
                                        {card.description}
                                    </p>
                                
                                    <CTAButton toLink={card.BtnLink} active={true}>
                                        {card.BtnText}
                                    </CTAButton>
                                </div>
                            }

                            {
                                card.order > 0 && 
                                <div className='p-7 flex flex-col gap-2 text-richblack-100'>
                                    <p className='text-xl text-richblack-5'>{card.heading}</p>
                                    <p>{card.description}</p>
                                </div>
                            }

                        </div>
                    )
                })
            }
        </div>
  )
}
